import React from 'react'

const Golang = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 98 128" {...props}>
    <path
      fill="#8cc5e7"
      d="M94.227 20.273c-3.046-6.227-10.409-.727-12.273-2.682C72.408 7.773 60.863 5.318 51.818 4.864h-5c-9.091.227-20.636 2.864-30.136 12.727-1.864 1.954-9.273-3.546-12.273 2.682-3.5 7.273 7.136 8 6.591 11.227-1.046 5.818-.364 14.455.454 22.955 1.273 14.409-9.5 48.909 12.909 62.773 4.227 2.636 15.636 4.091 25.546 4.318h.09c9.909-.227 19.954-1.682 24.182-4.318 22.454-13.864 11.682-48.364 13-62.773.773-8.5 1.454-17.136.454-22.954-.546-3.227 10.091-4 6.591-11.227z"
    />

    <path
      fill="#e0dedc"
      d="M65.091 24.682c-15.182 1.773-13.136 17.591-7.273 22.727 10.909 9.546 22.273 0 21-9.636-1.136-9.273-9-13.636-13.727-13.091z"
    />

    <path
      fill="#111212"
      d="M71.318 38.318a5.182 5.182 0 1 1-10.364 0 5.182 5.182 0 0 1 10.364 0z"
    />

    <path
      fill="#fff"
      d="M66.409 36.091a1.636 1.636 0 1 1-3.272 0 1.636 1.636 0 0 1 3.272 0z"
    />

    <path
      fill="#b8937f"
      d="M49.318 48.636c-7.273 1.091-9.864 3.182-9.318 6.455.909 5.364 18.046 4.773 18.591.273.455-3.864-6.409-7.136-9.273-6.727z"
    />

    <path d="M44.636 50.818c-1.227 4.455 9.864 3.773 9.591.909-.136-1.682-1.636-3.818-5.591-3.727-1.545.045-3.455.727-4 2.818z" />
    <path
      fill="#e0dedc"
      d="M45 58.045c-.409.182-1.091 4.636 1 4.864 1.409.136 5.273.591 6.182 0 1.773-1.136 1.591-3.864.591-4.545-1.682-1.091-7.318-.545-7.773-.318zM33.455 24.682c15.182 1.773 13.136 17.591 7.273 22.727-10.909 9.546-22.273 0-21-9.636 1.182-9.273 9.046-13.636 13.727-13.091z"
    />

    <path
      fill="#111212"
      d="M37.636 38.318a5.182 5.182 0 1 1-10.364 0 5.182 5.182 0 0 1 10.364 0z"
    />

    <path
      fill="#fff"
      d="M35.455 36.091a1.636 1.636 0 1 1-3.272 0 1.636 1.636 0 0 1 3.272 0z"
    />

    <path
      fill="#b8937f"
      d="M88 84.864c5 .046 2.546-10.682-.546-8.546-1.5 1.046-1.773 3.454-1.773 5.5 0 1.136.909 3 2.318 3.046zM10.591 84.864c-5 .046-2.546-10.682.546-8.546 1.5 1.046 1.773 3.454 1.773 5.5 0 1.136-.909 3-2.318 3.046zM78.5 117.818c-2.727-4.046-5.182-.909-9.136 1.091-1.864.954 3.091 4.364 8.636 1.818 1.454-.682 1.409-1.591.5-2.909zM20.091 118.273c2.727-4.046 5.182-.909 9.136 1.091 1.864.954-3.091 4.364-8.636 1.818-1.454-.682-1.409-1.591-.5-2.909z"
    />

    <path
      fill="#3c89bf"
      d="M85.727 21.364c-.273.954.954.818 1.409 3.773.182 1.091 4.091-1.591 2.5-3.546-1.318-1.636-3.682-1.182-3.909-.227zM12.864 21.364c.273.954-.954.818-1.409 3.773-.182 1.091-4.091-1.591-2.5-3.546 1.273-1.636 3.636-1.182 3.909-.227z"
    />
  </svg>
)

Golang.href = 'https://golang.org'

export default Golang
